"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@mui/styles");

var _Icon = require("../../Icon");

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    image: {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      overflow: 'hidden',
      cursor: 'inherit'
    }
  };
});

var MarketplaceProductImage = function MarketplaceProductImage(_ref) {
  var src = _ref.src,
      onLoad = _ref.onLoad,
      _ref$isDefaultCursor = _ref.isDefaultCursor,
      isDefaultCursor = _ref$isDefaultCursor === void 0 ? false : _ref$isDefaultCursor;
  var classes = useStyles();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isImgFail = _useState2[0],
      setImgFail = _useState2[1];

  (0, _react.useEffect)(function () {
    return setImgFail(false);
  }, [src]);
  (0, _react.useEffect)(function () {
    if (isImgFail && onLoad) {
      onLoad();
    }
  }, [isImgFail, onLoad]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !isImgFail && /*#__PURE__*/_react["default"].createElement("img", {
    src: src,
    alt: "",
    onLoad: onLoad,
    onError: function onError() {
      setImgFail(true);
    },
    className: classes.image
  }), isImgFail && /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    fontSize: 6.5,
    icon: "gift",
    isDefaultCursor: isDefaultCursor
  }));
};

var _default = /*#__PURE__*/(0, _react.memo)(MarketplaceProductImage);

exports["default"] = _default;